import { render, staticRenderFns } from "./productInformation.vue?vue&type=template&id=744578c8&scoped=true"
import script from "./productInformation.vue?vue&type=script&lang=js"
export * from "./productInformation.vue?vue&type=script&lang=js"
import style0 from "./productInformation.vue?vue&type=style&index=0&id=744578c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "744578c8",
  null
  
)

export default component.exports